// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7837980f","884":"534e5d22"}[chunkId] + ".chunk.js";
};